export const Logo = ({ height = 52 }) => (
  <span className="flex items-center" data-testid="brand-logo">
    <img src="/logo-mark.png" alt="Brol Baas — Geen rommel. Geen gedoe." style={{ height, width: "auto" }} />
  </span>
);
